import { MARKER_COLOR } from '../constants'

function getClusterMarkerStyle() {
  const cluster = {
    id: 'Mapstack Visualization Cluster',
    source: 'mapstack-points-cluster',
    type: 'circle',
    filter: ['has', 'point_count'],
    paint: {
      'circle-color': MARKER_COLOR,
      'circle-opacity': 1,
      'circle-radius': ['step', ['get', 'point_count'], 12, 100, 16, 750, 20],
      'circle-stroke-color': MARKER_COLOR,
      'circle-stroke-width': [
        'case',
        ['boolean', ['feature-state', 'hover'], false],
        12, // Hover state
        8 // Normal state
      ],
      'circle-stroke-opacity': 0.5
    }
  }

  const label = {
    id: 'Mapstack Visualization Label',
    source: 'mapstack-points-cluster',
    type: 'symbol',
    filter: ['has', 'point_count'],
    layout: {
      'text-field': '{point_count_abbreviated}',
      'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
      'text-size': 12
    },
    paint: {
      'text-color': '#ffffff' // White text for better contrast against purple
    }
  }

  const symbol = {
    id: 'Mapstack Visualization Unclustered Symbol',
    source: 'mapstack-points-cluster',
    type: 'circle',
    filter: ['!', ['has', 'point_count']],
    paint: {
      'circle-color': MARKER_COLOR,
      'circle-radius': 8,
      'circle-stroke-color': '#ffffff',
      'circle-stroke-width': [
        'case',
        ['boolean', ['feature-state', 'hover'], false],
        4, // Hover state
        2 // Normal state
      ]
    }
  }

  return {
    symbol,
    label,
    cluster
  }
}

export { getClusterMarkerStyle }
